import React from 'react';
import { ImageSourceBadge } from '../ui/ImageSourceBadge';
import type { EquipmentItem } from '../../types/content';
export function EquipmentCard({
  item,
  categoryTitle
}: {
  item: EquipmentItem;
  categoryTitle: string;
}) {
  return <article className="flex h-full flex-col bg-charcoal-900 ring-1 ring-white/10" data-id="element-29" data-mp="3s9nyl2inblkv">
      <div className="relative aspect-[4/3] overflow-hidden" data-id="element-30" data-mp="15qvpo3m4d5b">
        <img src={item.image.src} alt={item.image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-31" data-mp="64agvmadtkwm" />
        <ImageSourceBadge source={item.image.source} className="absolute bottom-3 right-3" data-id="element-32" data-mp="a4kp75lncnen" />
      </div>
      <div className="flex flex-1 flex-col p-6" data-id="element-33" data-mp="exdvvz0oe5td">
        <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-brand-light" data-id="element-34" data-mp="jvfn57899bfx">{categoryTitle}</p>
        <h3 className="mt-2 font-display text-[24px] font-bold uppercase leading-[1.02] text-white" data-id="element-35" data-mp="ousadt31gkj1">{item.name}</h3>
        {item.models && <p className="mt-2 text-sm text-steel-300" data-id="element-36" data-mp="tuocfms6e1vy">{item.models}</p>}
        <p className="mt-3 text-[15px] leading-relaxed text-steel-300" data-id="element-37" data-mp="360mu3wpyqpdp">{item.description}</p>
        <div className="mt-auto pt-6" data-id="element-38" data-mp="31233hj0fcpf0">
          <div className="flex items-baseline justify-between border-t border-white/10 pt-4" data-id="element-39" data-mp="3111stfnbm4xt">
            <span className="text-[12px] font-semibold uppercase tracking-[0.14em] text-steel-400" data-id="element-40" data-mp="2w3rx5i9c8x1j">Listed quantity</span>
            <span className="font-display text-[22px] font-bold text-white" data-id="element-41" data-mp="2s2y64g0ln24f">{item.quantity}</span>
          </div>
        </div>
      </div>
    </article>;
}